<template>
	<button type="button" class="copy-button" :class="size" :title="title" :aria-label="title" @click="copy">
		<AppIcon :name="IconName.CopySmall" :size="iconSize" :stroke-width="1.2" />
	</button>
</template>

<script setup lang="ts">
import AppIcon from "@/components/AppIcon.vue"
import { IconName } from "@/components/icons/registry"
import { useToastStore } from "@/stores/toastStore.ts"

const props = withDefaults(
	defineProps<{
		text: string
		title: string
		size?: "md" | "lg"
		iconSize?: number
	}>(),
	{
		size: "lg",
		iconSize: 14,
	}
)

const toastStore = useToastStore()

function copy(): void {
	navigator.clipboard.writeText(props.text)
	toastStore.success("notifications.copySuccess")
}
</script>

<style scoped>
.copy-button {
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	padding: 0;
	border: none;
	border-radius: var(--border-radius-full);
	background: none;
	color: var(--neutral-600);
	cursor: pointer;
	transition: color 0.2s ease;

	&:hover {
		color: var(--primary-green);
	}

	&.md {
		width: var(--size-icon-md);
		height: var(--size-icon-md);
	}

	&.lg {
		width: var(--size-icon-lg);
		height: var(--size-icon-lg);
	}
}
</style>
